import { ContactTypeEmojis, ContactTypes } from '../types';

export const contact_tags = [
  { label: ContactTypes.Family, emoji: ContactTypeEmojis.Family },
  { label: ContactTypes.Friend, emoji: ContactTypeEmojis.Friend },
  { label: ContactTypes.Neighbour, emoji: ContactTypeEmojis.Neighbour },
  { label: ContactTypes.Support, emoji: ContactTypeEmojis.Support },
  { label: ContactTypes.Work, emoji: ContactTypeEmojis.Work },
  { label: ContactTypes.School, emoji: ContactTypeEmojis.School },
  { label: ContactTypes.Emergency, emoji: ContactTypeEmojis.Emergency },
];
